module.exports = __webpack_public_path__ + "001.0fa98311.png";